import React, { useState, useEffect } from "react";
import cx from "clsx";
import VisibilitySensor from "react-visibility-sensor";
import { Parallax } from "react-scroll-parallax";
import { Container } from "react-grid-system";

import { VIS_OFFSET, VIS_MIN_TOP } from "@/constants";

import globalStyles from "@/styles/global.module.scss";
import sectionStyles from "./sections.module.scss";
import styles from "./section4.module.scss";

const renderParallaxImg = props => {
  const { bgImg, bgImgY, bgImgClassName, disableParallax } = props;

  return bgImg ? (
    <div className={cx(styles.bgImgContainer, bgImgClassName)}>
      <Parallax
        y={bgImgY || ["-500px", "-300px"]}
        disabled={disableParallax}
        className={styles.bgImg}
      >
        <div
          className={cx(globalStyles.background, globalStyles.fullWidthImage)}
        >
          {bgImg}
        </div>
      </Parallax>
    </div>
  ) : null;
};

const renderLineBorder = props => {
  const { imageBorder, borderClassName, disableParallax } = props;

  return imageBorder ? (
    <Parallax
      y={["15px", "-15px"]}
      disabled={disableParallax}
      className={cx(globalStyles.foreground, styles.borderContainer)}
    >
      <div
        className={cx(
          globalStyles.foreground,
          styles.imageBorder,
          borderClassName
        )}
      />
    </Parallax>
  ) : null;
};

const renderImgBg = props => {
  const { isDesktop, disableParallax, bgBottom, bgBottomY } = props;

  return bgBottom ? (
    <div className={styles.bgBottomContainer}>
      <Parallax
        y={bgBottomY || ["-50px", "50px"]}
        disabled={!isDesktop || disableParallax}
      >
        <div className={cx(globalStyles.background, styles.bgBottom)}>
          {bgBottom}
        </div>
      </Parallax>
    </div>
  ) : null;
};

const Section4 = props => {
  const {
    image,
    caption,
    imageClassName,
    isDesktop,
    containerClassName,
    innerClassName,
    children
  } = props;

  const [hasMounted, setMounted] = useState(false);
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    if (!hasMounted) setMounted(true);
  }, []); // eslint-disable-line

  return (
    <VisibilitySensor
      delayedCall
      partialVisibility
      offset={VIS_OFFSET}
      minTopValue={VIS_MIN_TOP}
      onChange={setVisible}
    >
      <div
        className={cx(
          sectionStyles.section,
          styles.container,
          containerClassName
        )}
      >
        <div
          className={cx(globalStyles.foreground, styles.inner, innerClassName)}
        >
          <div
            className={cx(globalStyles.foreground, imageClassName)}
            style={{ position: "relative" }}
          >
            <Container
              className={
                isDesktop
                  ? globalStyles.containerMax
                  : globalStyles.fullWidthImage
              }
              style={{ maxWidth: isDesktop ? undefined : "100%" }}
            >
              {renderImgBg(props)}
              {typeof image === "function" ? image({ isVisible }) : image}
              {renderLineBorder(props)}
              {renderParallaxImg(props)}
            </Container>
          </div>
          {caption ? (
            <Container className={globalStyles.containerMax}>
              <div
                className={cx(
                  !isDesktop && globalStyles.contentPaddingH,
                  globalStyles.caption,
                  globalStyles.foreground
                )}
              >
                {caption}
              </div>
            </Container>
          ) : null}

          {children}
        </div>
      </div>
    </VisibilitySensor>
  );
};

export default Section4;
